import React from "react";
import './TravianServerSelector.sass'
import {useV1Data} from "../../../react/hooks/useData";
import {ServerInstance} from "../../../api/ResponseTypes/travian";
import {GameIconTL} from "../../../react/components/ui/tIcon";

function getLegendsServerTypePriority(type: ServerInstance['travianServerType']) {
    switch (type) {
        case 'normal': return -1;
        default: return 25;
        case 'TTQ': return 100;
        case 'TNL':
        case 'NYS':
            return 50;
        case 'CW':
            return 30;
        case 'LocalServer':
            return 20;
    }
}

function serverSort(a: ServerInstance, b: ServerInstance): number {
    if (a.tmajor === 4 && b.tmajor === 4) {
        const typeCompare = getLegendsServerTypePriority(b.travianServerType) - getLegendsServerTypePriority(a.travianServerType);
        if (typeCompare !== 0) {
            return typeCompare;
        }
    }
    if (a.speed !== b.speed) {
        return b.speed - a.speed;
    }
    if (a.tmajor === 4 && b.tmajor === 4) {
        // International and Europe on top, coincidentally this aligns with sorting alphabetically from z to a.
        const regionCompare = b.url.split('.')[2]?.localeCompare(a.url.split('.')[2]) ?? 0;
        if (regionCompare !== 0) {
            return regionCompare;
        }
    }
    return a.url.localeCompare(b.url);
}

export default function TravianServerSelector() {
    const { data } = useV1Data<ServerInstance[]>('travian/serverInstance/displayable', null, raw => Object.values(raw), []);

    const serverTL = data.filter(instance => instance.tmajor === 4);
    const serverTK = data.filter(instance => instance.tmajor === 5);

    const legendsTypes = [...new Set(serverTL.map(instance => instance.travianServerType))].sort((a, b) => getLegendsServerTypePriority(b) - getLegendsServerTypePriority(a));

    return <div className='travianServerSelector'>
        <div>
            <h1>Legends</h1>

            {legendsTypes.map(type => {
                const servers = serverTL.filter(instance => instance.travianServerType === type).sort(serverSort);
                return <div>
                    <h3>{type}</h3>
                    {servers.map(instance => <div key={instance.id}><GameIconTL/> {instance.shortname}</div>)}
                </div>
            })}
        </div>
        <div>
            <h1>Kingdoms</h1>
        </div>
    </div>
}
